export default __webpack_public_path__ + "static/city-dbfafd5b76ebfb31c0b1d385ebd50e93.jpg";